import { Box, Modal, useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { WorkflowStepAction } from '@spike/masterdata-model';
import { FunctionComponent } from 'react';
import ListItem, { redAppointementStatusIds } from './ListItem';
import { ActionsPopup } from 'components/UI/ActionsPopup/ActionsPopup';
import { ActionButtonType } from 'components/UI/ActionsPopup/ActionButton';

const STATUS_LIST_MOBILE_MODAL_Z_INDEX = 10200;

export interface ListProps {
    actions: Array<WorkflowStepAction>;
    x?: number;
    y?: number;
    position?: 'fixed' | 'absolute';
    className?: string;
    onClick?: (statusId: number, statusName: string) => void;
    onClose: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            zIndex: 100,
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 14,
            border: '1px solid #000',
            background: '#FFF',
            padding: '10px 20px',
            minWidth: 150
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    })
);

export const List: FunctionComponent<ListProps> = props => {
    const classes = useStyles();

    const isMobile = useMediaQuery('(max-width:600px)');

    const x = props.x ?? 0;
    const y = props.y ?? 0;
    const position = props.position ?? 'absolute';

    const windowHeight = window.innerHeight;
    const dropDownDirection = y / windowHeight > 0.75 ? 'up' : 'down';
    const containerStyle =
        position === 'absolute'
            ? { position: 'absolute' as const, top: 0, right: 0 }
            : dropDownDirection === 'down'
            ? { position: 'fixed' as const, left: x, top: y }
            : { position: 'fixed' as const, left: x, bottom: windowHeight - y - 40 };

    const webView = (
        <Box
            className={classes.container}
            style={containerStyle}
        >
            {props.actions.map(step => (
                <ListItem
                    key={step.nextStatus.id}
                    step={step}
                    onClick={() => props.onClick && props.onClick(step.nextStatus.id, step.nextStatus.name)}
                />
            ))}
        </Box>
    );

    const mobilePopupActions: Array<ActionButtonType> = props.actions.map(step => ({
        label: step.nextStatus.name,
        onClick: () => props.onClick && props.onClick(step.nextStatus.id, step.nextStatus.name),
        color: redAppointementStatusIds.includes(step.nextStatus.id) ? '#EF4F57' : undefined
    }));

    const mobileView = (
        <Modal
            open={true}
            aria-labelledby="simple-dialog-title"
            className={classes.modal}
            style={{ zIndex: STATUS_LIST_MOBILE_MODAL_Z_INDEX }}
        >
            <ActionsPopup
                actions={mobilePopupActions}
                onClose={props.onClose}
            />
        </Modal>
    );

    return isMobile ? mobileView : webView;
};

export default List;
